import { createSelector } from 'reselect';
import { selectCurrentBrandId } from 'app/userPreferences/selectors';
import { selectUserBrands } from 'app/auth/selectors';

export const selectBrand = (state) => state.brand;
export const selectBrandLoading = (state) => state.loading;
export const selectBrandName = (state) => selectBrand(state)?.name;
export const selectBrandMarkets = (state) => state.markets;
export const selectIsBrandExist = (state) => state.isBrandExist;
export const selectBrandTemplates = (state) => state.templates;
export const selectBrandCallEndedStatus = (state) => state.callEndedStatus;
export const selectBrandSportsBookState = (state) => selectBrand(state)?.isSport;
export const selectBrandId = (state) => selectBrand(state).id;
export const selectBrandMarketId = (state) => selectBrand(state)?.market?.id;

export const selectCommonBrandVersion = (brandIdSelector) => createSelector(
  (state) => selectUserBrands(state),
  brandIdSelector,
  (userBrands, brandId) => {
    const currentBrand = userBrands?.find((brand) => brand.id === brandId);
    return currentBrand?.isNewVersion;
  },
);

export const selectCurrentBrand = (state) => createSelector(
  () => selectUserBrands(state),
  () => selectCurrentBrandId(state),
  (userBrands, id) => userBrands?.find((brand) => brand.id === id),
)();

export const selectCurrentBrandVersion = selectCommonBrandVersion((state) => selectCurrentBrandId(state));

export const selectBrandVersion = selectCommonBrandVersion((state) => selectBrandId(state.brands));
